import axios from 'axios';
import { logError } from 'Utils/Logger';
import { isNonAnonymousUser, getAccessToken } from 'Utils/UserCookie';
import { createApiTokenHandler } from './RefreshTokenHandler';

export class RequestService {
  // forceUseAccessToken in cases where the token isn't yet set in the AuthStore but it's available
  // from another source e.g. the user cookie
  static async send(config, forceUseAccessToken = null) {
    const { authenticate = false, customHeaders = {} } = config;

    try {
      return await createApiTokenHandler(async () => {
        const token = forceUseAccessToken || ((await isNonAnonymousUser()) && (await getAccessToken()));

        const headers = customHeaders;

        if (authenticate && token) {
          headers.Authorization = `Bearer ${token}`;
        }

        return axios({ ...config, headers });
      });
    } catch (e) {
      logError(e?.response?.data?.errorMessage || e);
      throw e;
    }
  }
}
